document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.review-slider__grid-button[data-read-more-text]').forEach(function (button) {
    const wrapper = button.closest('.review-slider__contents');
    if (!wrapper) return;

    const items = wrapper.querySelectorAll('.review-slider__item-grid');
    if (!items.length) return;

    const readMoreText = button.dataset.readMoreText || 'Ver Más Reseñas';
    const readLessText = button.dataset.readLessText || 'Ver Menos';

    let visibleCount = 0;

    function getInitialCount() {
      return window.innerWidth >= 981 ? 6 : 3;
    }

    function getStep() {
      return 3;
    }

    function updateItems() {
      items.forEach((item, index) => {
        if (index < visibleCount) {
          item.classList.add('is-visible');
        } else {
          item.classList.remove('is-visible');
        }
      });

      if (visibleCount >= items.length) {
        button.textContent = readLessText;
      } else {
        button.textContent = readMoreText;
      }
    }

    function init() {
      visibleCount = getInitialCount();
      updateItems();
    }

    button.addEventListener('click', function (e) {
      e.preventDefault();

      const initial = getInitialCount();

      if (visibleCount >= items.length) {
        visibleCount = initial;
      } else {
        visibleCount += getStep();

        if (visibleCount > items.length) {
          visibleCount = items.length;
        }
      }

      updateItems();
    });

    init();
  });
});